import { ClipboardArrowLeftIcon } from './ClipboardArrowLeftIcon';

/**
 * author: Google
 * id 1D6DD9E5-61EA-40E6-A19A-EF4BA71B0FC0
 * name clipboard-arrow-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-arrow-left.svg
 * tags
 */
export const AssignmentReturnIcon = ClipboardArrowLeftIcon;
export default AssignmentReturnIcon